import { render } from "./Expand.vue?vue&type=template&id=3cc911ce&scoped=true"
import script from "./Expand.vue?vue&type=script&lang=js"
export * from "./Expand.vue?vue&type=script&lang=js"

import "./Expand.vue?vue&type=style&index=0&id=3cc911ce&scoped=true&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc911ce"]])

export default __exports__